import React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
// import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
import { useDispatch } from 'react-redux';
import warningLogo from '../../../assets/warning.svg';
import styles from './DueActionConfirmationModalStyle.module.scss';
import { updateStatusForPasDueStart } from '../redux/sliceInspectionLetter';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 539,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
type TypesConfirmModal = {
  show: string;
  setOpenFrom: () => void;
  handleCallback: () => void;
};

export default function DueActionConfirmationModal({ show, setOpenFrom, handleCallback }: TypesConfirmModal): JSX.Element {
  const dispatch = useDispatch();
  const handleClick = () => {
    const idis = show.split('_');
    const payload = {
      jobOrderId: idis[0],
      vesselId: idis[1],
    };
    dispatch(updateStatusForPasDueStart({ payload, callback: handleCallback }));
    setOpenFrom();
  };
  return (
    <Modal
      open={show?.length > 0}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          {/* <DeleteModalIcon /> */}
          <img src={warningLogo} alt="Warning" height={100} width={100} />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          Proceeding would move the vessel from Due to Past Due.
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={() => {
              handleClick();
            }}
          >
            Proceed
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>Cancel</button>
        </div>
      </Box>
    </Modal>
  );
}
